import { useState, useEffect } from 'react'
import { showToast } from '@provi/provi-components'
import * as Sentry from '@sentry/browser'

import { uploadImages } from '../../../services/api'
import { trackEvent } from '../../../components/google-analytics'

export const useCNH = (goToNextScreen, creditPath, setIsLoading) => {
  const [filesNotUpload, setFilesNotUpload] = useState([])
  const [filesUploaded, setFilesUploaded] = useState([])
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)
  const [preview, setPreview] = useState()
  const [numberOfFiles, setNumberOfFiles] = useState(0)
  const [numberOfFilesInitial, setNumberOfFilesInitial] = useState(0)

  useEffect(() => {
    if (creditPath && creditPath.ReadCNHFrontSide && creditPath.ReadCNHFrontSide.length > 0) {
      setIsButtonDisabled(false)
      setFilesUploaded(creditPath.ReadCNHFrontSide)
      setNumberOfFiles(creditPath.ReadCNHFrontSide.length)
      setNumberOfFilesInitial(creditPath.ReadCNHFrontSide.length)
      setPreview(creditPath.ReadCNHFrontSide[0])
    }
  }, [creditPath])

  useEffect(() => {
    if (filesNotUpload.length > 0) {
      setIsButtonDisabled(false)
    }
  }, [filesNotUpload])

  const onSubmit = async e => {
    e.preventDefault()
    trackEvent({ category: 'CreditPath', action: 'Submit Documents', label: 'documentStatus' })

    setIsLoading(true)
    try {
      const urls = await uploadImages(filesNotUpload)
      const files = [...urls, ...filesUploaded]

      if (!files.length) {
        /**
         * An error happened with upload to firebase and returns empty array reseting the page to reset the state
         */
        setIsLoading(false)
        showToast('Ocorreu um erro ao enviar o arquivo. Tente novamente ou entre em contato com a Provi.')
        Sentry.captureException(new Error('onSubmit(CNH): files is empty'))

        setTimeout(() => {
          window.location.reload()
        }, 3000)

        return
      } else {
        goToNextScreen(files)
      }
    } catch (err) {
      showToast()
    }
  }

  return [
    isButtonDisabled,
    numberOfFiles,
    preview,
    setPreview,
    setFilesNotUpload,
    filesNotUpload,
    setNumberOfFiles,
    numberOfFilesInitial,
    onSubmit
  ]
}
